import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import { ClipboardCheck, ClipboardCopy, Download } from "lucide-react";
import { useState } from "react";

interface MfaRecoveryCodesProps {
	codes: string[];
	isAfterEnrollment: boolean;
	onDone: () => void;
}

export default function MfaRecoveryCodes({
	codes,
	isAfterEnrollment,
	onDone,
}: MfaRecoveryCodesProps) {
	const t = useTranslation();
	const [hasCopied, setHasCopied] = useState(false);
	const text = codes.join("\n");

	const copy = () => {
		void navigator.clipboard.writeText(text);
		setHasCopied(true);
		setTimeout(() => setHasCopied(false), 2000);
	};

	const download = () => {
		const url = URL.createObjectURL(new Blob([text], { type: "text/plain" }));
		const link = document.createElement("a");
		link.href = url;
		link.download = "baback-recovery-codes.txt";
		link.click();
		URL.revokeObjectURL(url);
	};

	return (
		<div className="flex flex-col gap-3 rounded border border-green-500/40 bg-green-500/5 p-4">
			<p className="text-sm font-medium">
				{t("accountSettings.mfa.recoveryCodesTitle")}
			</p>
			<p className="text-xs text-muted-foreground">
				{t("accountSettings.mfa.recoveryCodesDescription")}
				{isAfterEnrollment && ` ${t("accountSettings.mfa.otherSessionsSignedOut")}`}
			</p>
			<ul className="grid grid-cols-2 gap-x-6 gap-y-1 font-mono text-sm w-fit">
				{codes.map((code) => (
					<li key={code}>{code}</li>
				))}
			</ul>
			<div className="flex flex-wrap gap-2">
				<Button type="button" variant="outline" size="sm" onClick={copy}>
					{hasCopied ? (
						<ClipboardCheck className="size-4 text-green-500" />
					) : (
						<ClipboardCopy className="size-4" />
					)}
					{t("accountSettings.mfa.copy")}
				</Button>
				<Button type="button" variant="outline" size="sm" onClick={download}>
					<Download className="size-4" />
					{t("accountSettings.mfa.download")}
				</Button>
				<Button type="button" size="sm" onClick={onDone}>
					{t("accountSettings.mfa.done")}
				</Button>
			</div>
		</div>
	);
}
